import { InnerPageHero } from "../components/InnerPageHero";
import { Members } from "../components/Members";

export function MembersPage() {
  return (
    <main id="top">
      <InnerPageHero kicker="AIYSS / MEMBERS" title="運営メンバー" />
      <Members />
    </main>
  );
}
